import type { FC, SVGProps } from 'react';

export const StarIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    fill="none"
    viewBox="0 0 16 26"
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={26}
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.59131 5.85535C7.73726 5.56344 8.09233 5.44286 8.38428 5.58679C8.50071 5.64408 8.59554 5.73892 8.65283 5.85535L10.7495 10.1073L15.4419 10.7899C15.7653 10.838 15.9908 11.1374 15.9409 11.4608C15.9224 11.5901 15.8614 11.7082 15.769 11.7987L12.3745 15.1093L13.1763 19.7831C13.2315 20.1045 13.0153 20.4093 12.6938 20.4647C12.5664 20.4868 12.4333 20.4661 12.3188 20.4052L8.12158 18.1991L3.92529 20.4052C3.82772 20.4567 3.71699 20.4804 3.60693 20.4725C3.497 20.4646 3.39144 20.426 3.30225 20.3612C3.21297 20.2964 3.14356 20.2076 3.10205 20.1053C3.06064 20.0033 3.04821 19.8916 3.06689 19.7831L3.86963 15.1093L0.474121 11.7987C0.36188 11.6892 0.297538 11.5395 0.29541 11.3827C0.293331 11.2258 0.353956 11.0743 0.463379 10.9618C0.553862 10.8695 0.672027 10.8085 0.80127 10.7899L5.49365 10.1073L7.59131 5.85535Z"
    />
  </svg>
);
